// All of the content in the first project

import { PortfolioImg3 } from "../projectContent/PortfolioImg3";
import { PortfolioImg5 } from "../projectContent/PortfolioImg5";
import { PortfolioImg7 } from "../projectContent/PortfolioImg7";
import { TextQaImg1 } from "../projectContent/TextQaImg1";
import { ProjectNameTitle } from "../projectContent/ProjectNameTitle";
import { PortfolioDescription } from "../projectContent/PortfolioDescription";
import { PortfolioContentOneJustArt } from "./PortfolioContentOneJustArt";
import { Link } from "react-router-dom";
import { useRef } from "react";

export function PortfolioContentOne() {
  const myRef = useRef(null);

  const executeScroll = () => myRef.current.scrollIntoView();
  // run this function from an event handler or an effect to execute scroll

  return (
    <section id="intro">
      <div className="container">
        <div className="intro-name">
          <h1 className="buyan">
            TEXT <br></br>
            Q&amp;A
          </h1>
        </div>
        <div id="intro-job-title">
          <ProjectNameTitle
            desc="QUESTION &amp; ANSWERING APP"
            job="FRONTEND / FULL-STACK DEVELOPMENT"
          />

          <p>
            <div className="next-project-2" onClick={executeScroll}>
              <u>
                <b>Visit Text Q&amp;A</b> →
              </u>{" "}
            </div>
          </p>

          <PortfolioDescription
            sentence="Text Q&A is an interactive, real-time question-and-answer
              app designed to enhance the experience of both host
              speaker and remote audiences."
          />
          <TextQaImg1 />
          <div className="standard-project-description">
            <p>
              The app allows the host to receive and address guest questions in
              real time, whereas guests get real-time answers to their
              questions. The app allows for seamless bridging between host and
              guest.
            </p>
          </div>

          {/* ONE */}
          {/* ONE */}
          {/* ONE */}
          <PortfolioImg3
            // MOBILE
            backgroundPic="/images/qa1-mobile-blue-background-4.webp"
            t1="/images/x-homepage-3.png"
            b1="/images/x-guest-login-3.png"
          />
          <PortfolioImg5
            // DESKTOP
            backgroundPic="images/qa1-blue-background.webp"
            desc="dssm bvzmj fdv fdvfds vfds f"
            l1="/images/x-homepage-3.png"
            r1="/images/x-guest-login-3.png"
          />
          {/* ONE */}
          {/* ONE */}
          {/* ONE */}

          <div className="standard-project-description">
            <p>
              Taken from a single idea to enable seamless and instant
              communication between host and guest, to a well-designed and fully
              functional app with growing clientele.
              <br />
              <br />
              Real-time updates to the UI, speedy performance, and seamless
              client-side interactions were achieved by utilizing Next.js.
              <br />
              <br />
              Efficient traffic management with fast performance, whilst
              enabling instant activity and updates in the backend was
              facilitated with Node.js.
              <br />
              <br />
              MongoDB serving as a reliable database to store user data, whilst
              keeping Q&A information.
              {/* <br />
              <br />
              SSR for fast initial loads, dynamic routing, efficient data
              fetching, and built-in optimizations. */}
            </p>
          </div>

          {/* TWO */}
          {/* TWO */}
          {/* TWO */}
          <PortfolioImg3
            // DESKTOPs
            backgroundPic="/images/qa1-mobile-blue-background-4.webp"
            t1="/images/x-dashboard-1.png"
            t2="/images/x-default.png"
            b1="/images/x-dashboard-searched.png"
            b2="/images/x-dashboard-searched-results.png"
          />
          <PortfolioImg5
            // DESKTOP
            backgroundPic="images/qa1-blue-background.webp"
            l1="/images/x-dashboard-1.png"
            l2="/images/x-initial-state.png"
            r1="/images/x-dashboard-searched.png"
            r2="/images/x-dashboard-searched-results.png"
          />
          {/* TWO */}
          {/* TWO */}
          {/* TWO */}

          <div className="standard-project-description">
            <p>
              Text Q&A was built to be compatible for use within all forms of
              presentations for both host and guest, such as lectures, seminars,
              and conferences.
              <br />
              <br />
              With only host speakers being required to sign up, a secure and
              reliable system was facilitated with Auth0, a cloud-based
              identity-as-a-service.
              <br />
              <br />
              Next.js server-side rendering via getServerSideProps ensured a
              fast initial page load. Combined client-side fetching with React
              state management to handle real-time updates.
              {/* for guest questions,
              allowing the UI to instantly show new data (guests question),
              without the need for the user to refresh the page. */}
              {/* <br />
              <br />
              useMemo, a React.js hook was also utilized in other parts of the
              app to cache results of a calculation between re-renders, such as
              search bars. */}
            </p>
          </div>

          {/* THREE */}
          {/* THREE */}
          {/* THREE */}
          <PortfolioImg3
            // DESKTOP
            backgroundPic="/images/qa1-mobile-blue-background-4.webp"
            t1="/images/x-dashboard-no-topics-2.png"
            t2="/images/x-default.png"
            b1="/images/x-dashboard-no-modal.png"
            b2="/images/x-dashboard-show-modal-3.png"
          />
          <PortfolioImg5
            // DESKTOP
            backgroundPic="images/qa1-blue-background.webp"
            l1="/images/x-dashboard-no-topics-2.png"
            l2="/images/x-initial-state.png"
            r1="/images/x-dashboard-no-modal.png"
            r2="/images/x-dashboard-show-modal-3.png"
          />
          {/* THREE */}
          {/* THREE */}
          {/* THREE */}

          <div className="standard-project-description">
            <p>
              Next.js API route was leveraged to ensure smooth and instant
              communication between frontend, and backend data processing
              through asynchronous requests.
              <br />
              <br />
              React.js custom hooks were purposed to interact with serverless
              API for CRUD operations. Promotes a Don't Repeat Yourself (DRY)
              approach.
            </p>
          </div>

          {/* FOUR */}
          {/* FOUR */}
          {/* FOUR */}
          <PortfolioImg3
            // DESKTOP
            backgroundPic="/images/qa1-mobile-blue-background-4.webp"
            t1="/images/x-eventid-host-1-2.png"
            t2="/images/x-default.png"
            b1="/images/x-eventid-host-3.png"
            b2="/images/x-initial-state.png"
          />

          <PortfolioImg5
            // DESKTOP
            backgroundPic="images/qa1-blue-background.webp"
            l1="/images/x-eventid-host-1-2.png"
            l2="/images/x-initial-state.png"
            r1="/images/x-eventid-host-3.png"
            r2="/images/x-initial-state.png"
          />
          {/* FOUR */}
          {/* FOUR */}
          {/* FOUR */}

          <div className="standard-project-description">
            <p>
              WebSockets bring real-time functionality and communication to the
              live chat app, as it enables the host to keep track of live
              questions from guest users.
            </p>
            {/* <p>
              I anticipate more advanced Q&A data types to be featured in the
              app (polls, questionnaires, diagrams) - MongoDB schema was
              employed to hold and process such data, facilitating future plans.
            </p> */}
          </div>

          {/* FIVE */}
          {/* FIVE */}
          {/* FIVE */}
          <PortfolioImg3
            // DESKTOP
            backgroundPic="/images/qa1-mobile-blue-background-4.webp"
            t1="/images/x-eventid-guest-2.png"
            t2="/images/x-default.png"
            t3="/images/x-default.png"
            b1="/images/x-eventid-guest-a-2.png"
            // b2="/images/x-eventid-guest-b.png"
            // b3="/images/x-eventid-guest-c.png"
          />
          <PortfolioImg5
            // DESKTOP
            backgroundPic="images/qa1-blue-background.webp"
            l1="/images/x-eventid-guest-2.png"
            l2="/images/x-initial-state.png"
            l3="/images/x-initial-state.png"
            r1="/images/x-eventid-guest-a-2.png"
            // r2="/images/x-eventid-guest-b.png"
            // r3="/images/x-eventid-guest-c.png"
          />
          {/* FIVE */}
          {/* FIVE */}
          {/* FIVE */}

          <div className="standard-project-description">
            <p>
              Working in partnership with a backend developer, I collaborated in
              using Node.js to build a user image upload system, where we
              utilized Formidable for secure file parsing, while utilizing
              Cloudinary for secure cloud storage and to provide back a working
              url.
            </p>
          </div>

          {/* SIX */}
          {/* SIX */}
          {/* SIX */}
          <PortfolioImg3
            // DESKTOP
            backgroundPic="/images/qa1-mobile-blue-background-4.webp"
            t1="/images/x-edit-topic-dashboard-backg.png"
            t2="/images/x-edit-topic-modal-2.png"
            b1="/images/x-edit-topic-page-2.png"
            b2="/images/x-default.png"
          />
          <PortfolioImg5
            // DESKTOP
            backgroundPic="images/qa1-blue-background.webp"
            l1="/images/x-edit-topic-dashboard-backg.png"
            l2="/images/x-edit-topic-modal-2.png"
            r1="/images/x-edit-topic-page-2.png"
            r2="/images/x-initial-state.png"
          />
          {/* SIX */}
          {/* SIX */}
          {/* SIX */}

          <div className="standard-project-description">
            <p>
              Prioritizing writing clean, well-structured, and maintainable code
              throughout development. Developed working knowledge with debugging
              tools, such as Chrome DevTools.
            </p>
          </div>

          <div className="visit-project-link">
            <br />
            <p>
              <b>
                <Link to={"/textqa-art"}>See Text Q&A Artwork Here →</Link>
              </b>
              <br />
              <br />
              <a href="https://github.com/sho88/text-askme" target={"_blank"}>
                <b>GitHub Repository →</b>
              </a>
              <br />
              <br />
              <div className="next-project-2">
                <a href="https://text-qa.co.uk" target={"_blank"}>
                  <u>
                    <b>Visit Text Q&amp;A</b>
                  </u>
                  {"  "}→
                  <br />
                  <div className="demo-login-details" ref={myRef}>
                    <b>Demo Host Login:</b>
                    <br />
                    username: jamesdoe@hotmail.com
                    <br />
                    password: Password123*
                    <br />
                    <br />
                    <b>Demo Guest Event Pin:</b>
                    <br />
                    215155
                    <br />
                    563016
                    <br />
                    <br />
                    <br />
                    <br />
                  </div>
                </a>
                <Link to={"/canvas"} className="next-project">
                  Next Project →
                </Link>{" "}
                {"  "}
              </div>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
